import { formatMoney, tr } from 'mmfintech-commons'
import { AmountValueWrapper } from './AmountValue.styled'

export const AmountValue = ({ amount, currency }) => {
  return (
    <AmountValueWrapper>
      <div className='amount-label'>{tr('FRONTEND.BANKING.COMMON.AMOUNT_LABEL', 'Amount')}</div>
      <span data-test='amount' className='amount'>
        {formatMoney(amount, currency)}
      </span>
    </AmountValueWrapper>
  )
}
